module.exports = __webpack_public_path__ + "static/img/image_sd.cb518b80.svg";